<div class="SDeskSidePanel-GreyBackground"></div>

<app-blade-right   size="blade-large">
  <div class="p-10 p-b-0">
    <i (click)="this.close()" class="fas fa-times fa-2x float-end divLink"></i>
    <h3>Create New Filter</h3>
  </div>
  <hr>
  <div class="container p-0">

    <div class="row" >
      <div class="col-sm-2 formHeader alignMiddle p-10">
        Filter Name <span class="text-danger">*</span>
      </div>
      <div class="col-sm p-10">
        <input [(ngModel)]="data.name" type="text" class="form-control"  placeholder="Enter Filter Name" autocomplete="off">

      </div>
    </div>

    <div class="m-t-20">
      <div (click)="save()" class="btn btn-primary">Save</div>
      <div (click)="close()" class="btn btn-cancel">Cancel</div>
    </div>

  </div>
</app-blade-right>
